module.exports = __webpack_public_path__ + "img/323.f124b6b1.jpg";